import { Box, Divider, Typography } from "@mui/material";
import { format } from "date-fns";
import { TextFieldProps, useFieldValue } from "react-admin";


interface DateTimeFieldProps extends TextFieldProps {
    split?: boolean
}

const sxSplitDateTime = {
    display: 'flex',
    flexDirection: "column",
    padding: "2px 8px",
    "& hr": {
        maxWidth: "60px"
    }

}
export const DateTimeField = (props: DateTimeFieldProps) => {
    const { split = false, className, sx, variant = "body2" } = props;
    const value = useFieldValue(props);

    if (value) {
        const dateTime = (value: string | Date) => {

            return [format(value, 'P'), format(value, "HH:mm:ss")]
        }
        const [date, time] = dateTime(value);
        return split
            ? (
                <Box sx={sxSplitDateTime}                >
                    <Typography component="div" variant="body2">
                        {date}
                    </Typography>
                    <Divider />
                    <Typography component="div" variant="caption">
                        {time}
                    </Typography>
                </Box>
            )
            : (
                <Typography component="span" variant={variant} className={className}  sx={sx} >
                    {format(value, 'MMM-dd HH:mm:ss')}
                </Typography>
            )

    }
    return null;
}